import React from 'react'
import { useDispatch } from 'react-redux'
import { useHistory } from 'react-router-dom'
import { displayNotification } from '../../../actions/notificationsActions'
import './ownershipComponent.scss'
import { updateVehicle } from '../../refiApp/refiActions'


interface OwnershipComponentProps {
  vehicle?: any
}

interface OwnershipStatus {
  value: string
  label: string
  eligible: boolean
}

const ownershipStatuses: OwnershipStatus[] = [
  {
    value: 'Owned',
    label: 'Owned - Paid in full',
    eligible: false,
  },
  {
    value: 'Financed',
    label: 'Financed - Making payments',
    eligible: true,
  },
  {
    value: 'Leased',
    label: 'Leased - Making payments',
    eligible: true,
  },
  {
    value: 'Sold',
    label: 'I no longer own this vehicle',
    eligible: false,
  },
]

const OwnershipComponent: React.FC<OwnershipComponentProps> = ({ vehicle }) => {
  const dispatch = useDispatch()
  const history = useHistory()

  const handleOwnershipStatusSelect = async (status: OwnershipStatus) => {
    if (!vehicle) {
      dispatch(displayNotification('Vehicle information is missing', 'error') as any)
      return
    }

    if (!status.eligible) {
      dispatch(displayNotification('Only vehicles that are currently financed or leased are eligible for a refinanced loan.', 'error') as any)
      return
    }

    try {
      await dispatch(updateVehicle({ ...vehicle, ownership_status: status.value }) as any)
      history.push('/refiApp/financing/apply/applicant-info')
    } catch (err) {
      dispatch(displayNotification('Failed to update vehicle', 'error') as any)
    }
  }

  return (
    <div className="ownership-status-page">
      <div className="ownership-question">
        <h1 className="ownership-question__title">
          What's your ownership status?
        </h1>
      </div>
      <div className="ownership-options">
        {ownershipStatuses.map((status) => (
          <button
            key={status.value}
            className={`ownership-option ${
              status.value === 'Financed' ? 'ownership-option--primary' : ''
            }`}
            onClick={() => handleOwnershipStatusSelect(status)}
          >
            {status.label}
          </button>
        ))}
      </div>
    </div>
  )
}

OwnershipComponent.displayName = 'Ownership Component'

export default OwnershipComponent
